import { Link } from "react-router-dom";
import type { AccessibleAppSummary } from "@/app/types";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface DashboardPageProps {
  apps: AccessibleAppSummary[];
}

export function DashboardPage({ apps }: DashboardPageProps) {
  return (
    <div className="grid gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Admin Dashboard</CardTitle>
          <CardDescription>Select an app to continue.</CardDescription>
        </CardHeader>
      </Card>

      {apps.length === 0 ? (
        <Card>
          <CardContent className="pt-6">
            <p className="text-sm text-muted-foreground">No app pages are registered yet.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {apps.map(app => (
            <Card key={app.serviceKey}>
              <CardHeader>
                <CardTitle className="text-base">{app.displayName}</CardTitle>
                <CardDescription>{app.serviceKey}</CardDescription>
              </CardHeader>
              <CardContent>
                <Link to={app.webBasePath} className="text-sm font-medium text-foreground underline underline-offset-4">
                  Open app
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}

export function NoAppAccessCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>No app access granted</CardTitle>
        <CardDescription>Your account is authenticated, but no web apps are enabled for it yet.</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">Ask an administrator to enable at least one service for your account.</p>
      </CardContent>
    </Card>
  );
}
